import { type FC, type ReactNode } from "react";

import { Anchor, VisuallyHidden } from "@mantine/core";

import { TOP_PERFORMER_LEARN_MORE_LINK_URL } from "../../../lens-creator-payout/constants";
import { formatWithUSFormat } from "../../../lens-stats/formatters/formatNumbers";
import { OpensInNewTab } from "../messages.generated";

import {
    band,
    criteriaLink,
    eyebrow,
    step,
    stepBody,
    stepNumber,
    stepTitle,
    steps,
} from "./HowPayoutsWorkBand.module.css";
import {
    HowPayoutsWork,
    SeeFullCriteria,
    StepCriteriaBody,
    StepCriteriaTitle,
    StepPaidBody,
    StepPaidTitle,
    StepReachBody,
    StepReachBodyNoThreshold,
    StepReachTitle,
    StepReachTitleNoThreshold,
} from "./messages.generated";

interface StepProps {
    index: number;
    title: ReactNode;
    body: ReactNode;
}

const Step: FC<StepProps> = ({ index, title, body }) => (
    <li className={step}>
        <span className={`heading-h700 ${stepNumber}`} aria-hidden="true">
            {index}
        </span>
        <div>
            <div className={`heading-h600 ${stepTitle}`}>{title}</div>
            <div className={`paragraph-p300 ${stepBody}`}>{body}</div>
        </div>
    </li>
);

export const HowPayoutsWorkBand: FC<{ postersThreshold: number | null }> = ({ postersThreshold }) => {
    const threshold = postersThreshold === null ? null : formatWithUSFormat(postersThreshold);
    return (
        <section className={band}>
            <h2 className={`heading-h400 ${eyebrow}`}>
                <HowPayoutsWork />
            </h2>
            <ol className={steps}>
                <Step
                    index={1}
                    title={threshold ? <StepReachTitle threshold={threshold} /> : <StepReachTitleNoThreshold />}
                    body={threshold ? <StepReachBody threshold={threshold} /> : <StepReachBodyNoThreshold />}
                />
                <Step
                    index={2}
                    title={<StepCriteriaTitle />}
                    body={
                        <>
                            <StepCriteriaBody />{" "}
                            <Anchor
                                href={TOP_PERFORMER_LEARN_MORE_LINK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={criteriaLink}
                            >
                                <SeeFullCriteria />
                                <VisuallyHidden>
                                    <OpensInNewTab />
                                </VisuallyHidden>
                            </Anchor>
                        </>
                    }
                />
                <Step index={3} title={<StepPaidTitle />} body={<StepPaidBody />} />
            </ol>
        </section>
    );
};
